import React from "react";
import { AbortControllerProvider } from "components/hooks/useAbortController";

function AbortOnLeave(Component) {
  return (props) => (
    <AbortControllerProvider>
      <Component {...props} />
    </AbortControllerProvider>
  );
}

export default AbortOnLeave;
